import { get, patch, post } from '../utils/networking';

export type OnboardingRole = 'GENERAL_MANAGER' | 'HR' | 'LEADER' | 'SAFETY_REP' | 'OTHER';
export type OnboardingGoal = 'TEAM_SAFETY' | 'WORK_ENVIRONMENT' | 'SAFETY_ROUNDS' | 'DEMO';

/** «Kom i gang» for the logged in user, kept on the server so it follows them */
export type UserOnboarding = {
  firstName: string | null;
  companyName: string | null;
  /** Made the account through «Prøv gratis» */
  fromSignup: boolean;
  role: OnboardingRole | null;
  goal: OnboardingGoal | null;
  recommendedGoal: OnboardingGoal | null;
  firstStep: { doneAt: string; type: string | null; id: number | null } | null;
  checklistHidden: boolean;
  tipsClosed: boolean;
  /** The points of «Kom i gang», ticked off from the data */
  checklist: Array<{ key: string; done: boolean }>;
  firstStepDone: boolean;
  /** Where the steps for mapping the working environment lead */
  workEnvironment?: {
    /** The only team of the company, chosen for the safety representative */
    soleTeamId: number | null;
    /** The survey to assess the risk of: answers are being collected, the risk is ready, or too few answered */
    assessSurvey: { id: number; state: 'collecting' | 'ready' | 'insufficient' } | null;
  };
  /** «Kom i gang» is there until every point is done */
  gettingStarted: boolean;
};

export type UserOnboardingPatch = Partial<
  Pick<UserOnboarding, 'role' | 'goal' | 'checklistHidden' | 'tipsClosed'>
>;

export const getUserOnboarding = () => get<UserOnboarding>('/api/me/onboarding');
export const updateUserOnboarding = (changes: UserOnboardingPatch) =>
  patch<UserOnboarding>('/api/me/onboarding', changes);

/** The guidance made the first survey */
export const markFirstStepDone = (type: 'survey' | 'workEnvironmentSurvey') =>
  post<UserOnboarding>('/api/me/onboarding/first-step', { type });
